class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', async (event) => {
      event.preventDefault();
      this.open(cartLink)

      const cartProducts = document.querySelectorAll("#CartDrawer-CartItems tr");
      
      const productTitlesList = []
      cartProducts.forEach((eachProduct) => {
        const productTitle = eachProduct.querySelector(".cart-item__details a").textContent;
        productTitlesList.push(productTitle);
      })

      const cartValue = document.querySelector(".cart-drawer__footer .totals__subtotal-value span").textContent;
      const clevertapData = {
        Products_In_Cart: cartProducts.length,
        Product_Names: productTitlesList,
        Cart_Value: cartValue,
        Current_Page: cartLink.dataset.currentPage
      }

      dataLayer.push({
        event: "Cart_Viewed",
        Products_In_Cart: cartProducts.length,
        Product_Names: productTitlesList,
        Cart_Value: cartValue,
        Current_Page: cartLink.dataset.currentPage,
        clevertap: clevertapData
      });
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    // pushing state to handle back button for cart open
    const url = new URL(location);
    if (location.href.indexOf('cartOpen=true') == -1) {
      url.searchParams.set("cartOpen", "true");
      window.history.pushState({'cart':'open'}, "", url);
    }
    
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    this.cartUpdate();    
  }
  
  async cartUpdate(){
    const cartJson = await fetch('/cart.json').then( response => response.json());
    const cartItemCount = Number(document.querySelector(".cart-count-bubble span:first-child").innerText);
    
    if (cartJson.item_count !== cartItemCount) {
      let cartElemopen = document.querySelector('cart-drawer');
      fetch(`/?sections=${cartElemopen.getSectionsToRender().map((section) => section.id).toString()}`)
      .then(response => response.json())
      .then(data => cartElemopen.renderContents({sections: data}))
    } 

    const cartDrawer = document.querySelector('cart-drawer');
    const cartInner = cartDrawer.querySelector(".drawer__inner");
    const cartPrice = parseInt(cartInner.dataset.cartPrice);
    const freebieThreshold = parseInt(cartInner.dataset.freebieThreshold);

    const confetti = this.querySelector('#e0DQ82qcIov1');
    if (confetti) {
      if (cartPrice < freebieThreshold) {
        confetti.classList.add('small-confetti');
      }
      else {
        confetti.classList.remove('small-confetti');
      }
    }
  }

  close() {
    // remove Url after close of cart
    let currentPageUrl = window.location.href.replace(/[?&]cartOpen=true/g, '');
    window.history.replaceState({}, document.title, currentPageUrl);
    
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, showCart) {   
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      if (document.querySelector('quantity-message') && window.innerWidth <= 768) {
        setTimeout(() => {
          let confettiShooterCount = document.querySelector('quantity-message')?.querySelector('noscript').getAttribute('data-cart-count');   
          if (confettiShooterCount >= 1 && !document.querySelector("collection-progressbar")) {
            this.open();
          }
        }, 2000);
      }
      else if (!document.querySelector("collection-progressbar")){
        showCart?null:this.open();
      } 
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    const sections = [
    {
      id: 'cart-drawer',
      selector: '#CartDrawer'
    },
    {
      id: 'cart-icon-bubble'
    }
  ];

  if (document.getElementById('quantity-message')) {
    sections.push({
      id: 'quantity-message'
    });
  }

  return sections;
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  addFreebie() {
    fetch('/cart', {
      method: 'POST', 
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then((data) => {
      cartdata(data);
    })

    function cartdata(cart) {
      let eligibleCartPrice = 0;
      let eligibleCartCount = 0;

      cart.items.forEach((cartItem) => {
        if (!cartItem.properties["affiliateProduct"]) {
          eligibleCartPrice += cartItem.final_line_price;
          eligibleCartCount += cartItem.quantity;
        }
      })

      let cartSubtotal = eligibleCartPrice / 100;
      let cartCount = eligibleCartCount;
      let updateCart = false;
      let cleverTapDataArr = [];
  
      // No FREEBIE with giftcard on orders
      const giftCard = cart.items.filter(
        (item) => item.product_id == '6708711129181'
      )

      for (let i = 0; i < cart.items.length; i++) {
        if (cart.items[i].product_title == 'COD Charges') {
            cartCount -= 1
        }
      }
    
      let tagPresenceCount = 0
      let cartVariantIds = cart.items.map( item => item.id).join(', ');
      let cartAjax = document.querySelector('.cart-ajax');
      
      if (cartAjax) {
        let offer1FreebieValue = cartAjax.getAttribute('data-eligible-price-1');
        let offer2FreebieValue = cartAjax.getAttribute('data-eligible-price-2');
        let offer3FreebieValue = cartAjax.getAttribute('data-eligible-price-3');
        let offer4FreebieValue = cartAjax.getAttribute('data-eligible-price-4');

        let eligibleVariantIds = cartAjax.getAttribute('data-eligible-variantids-1');
        let eligibleVariantIds2 = cartAjax.getAttribute('data-eligible-variantids-2');
        let eligibleVariantIds3 = cartAjax.getAttribute('data-eligible-variantids-3');
        let eligibleVariantIds4 = cartAjax.getAttribute('data-eligible-variantids-4');
        let offer3MinCartQty = cartAjax.getAttribute('data-eligible-qty');
        let offer3MinCartQty2 = cartAjax.getAttribute('data-eligible-qty-two');
        let offer3MinCartQty3 = cartAjax.getAttribute('data-eligible-qty-three');
        let offer3MinCartQty4 = cartAjax.getAttribute('data-eligible-qty-four');

        let variantIdsArr = eligibleVariantIds?.split(',');
        let variantIdsArr2 = eligibleVariantIds2?.split(',');
        let variantIdsArr4 = eligibleVariantIds3?.split(',');
        let variantIdsArr5 = eligibleVariantIds4?.split(',');

        let offer1FreebieVariantIds = variantIdsArr?.filter(function(id) {
          return !cartVariantIds.includes(id);
        });

        let offer2FreebieVariantIds = variantIdsArr2?.filter(function(id) {
          return !cartVariantIds.includes(id);
        });

        let offer3FreebieVariantIds = variantIdsArr4?.filter(function(id) {
          return !cartVariantIds.includes(id);
        });

        let offer4FreebieVariantIds = variantIdsArr5?.filter(function(id) {
          return !cartVariantIds.includes(id);
        });

        // Offer 3 :: quantity threshold
        let eligibleQtyVariantIds = cartAjax.getAttribute('data-eligible-qty-variantsids'); 
        let eligibleQtyVariantIds2 = cartAjax.getAttribute('data-eligible-qty-variantsids-two');
        let eligibleQtyVariantIds3 = cartAjax.getAttribute('data-eligible-qty-variantsIds-three');
        let eligibleQtyVariantIds4 = cartAjax.getAttribute('data-eligible-qty-variantsIds-four');
        
        let variantIdsArr3 = eligibleQtyVariantIds?.split(',');
        let variantIdsArr3two = eligibleQtyVariantIds2?.split(',');
        let variantIdsArr3three = eligibleQtyVariantIds3?.split(',');
        let variantIdsArr3four = eligibleQtyVariantIds4?.split(',');
        
        let offer3MinCartQtyVariantIds = variantIdsArr3?.filter(function(id) {
          return !cartVariantIds.includes(id);
        });
        let offer3MinCartQtyVariantIds2 = variantIdsArr3two?.filter(function(id) {
          return !cartVariantIds.includes(id);
        });
        let offer3MinCartQtyVariantIds3 = variantIdsArr3three?.filter(function(id) {
          return !cartVariantIds.includes(id);
        });
        let offer3MinCartQtyVariantIds4 = variantIdsArr3four?.filter(function(id) {
          return !cartVariantIds.includes(id);
        });
      
        let eligibleQtyTags = cartAjax.getAttribute('data-eligible-qty-tags');
        let eligibleQtyTags2 = cartAjax.getAttribute('data-eligible-qty-tags-two');
        let eligibleQtyTags3 = cartAjax.getAttribute('data-eligible-qty-tags-three');
        let eligibleQtyTags4 = cartAjax.getAttribute('data-eligible-qty-tags-four');
        
        let offer3MinCartQtyTags = eligibleQtyTags?.split(',');
        let offer3MinCartQtyTags2 = eligibleQtyTags2?.split(',');
        let offer3MinCartQtyTags3 = eligibleQtyTags3?.split(',');
        let offer3MinCartQtyTags4 = eligibleQtyTags4?.split(',');

       let mmAjaxcartItems = document.querySelectorAll('cart-drawer .cart-item');
       let tagPresenceCount = 0;
        
        // Offer 3 :: quantity threshold tag mapping
        mmAjaxcartItems.forEach(function(item) {
            let lineItemAttr = item.dataset.variantTags;
            
            if (lineItemAttr && lineItemAttr.length && (lineItemAttr.includes(offer3MinCartQtyTags) || lineItemAttr.includes(offer3MinCartQtyTags2) || lineItemAttr.includes(offer3MinCartQtyTags3) || lineItemAttr.includes(offer3MinCartQtyTags4))) {
              item.querySelectorAll('quantity-input input').forEach(e => {
                let lineItemQty = e.value;
                tagPresenceCount += parseInt(lineItemQty);
              });
            }
        });  
        
        let freebieVariantObjects = []
        let freebieVariantIds = []
  
        function createVariantsObject(variantIds) {
          return variantIds.map((variantId) => ({
              id: variantId,
              properties: { _freebieItem: 'true' },
          }))
        }

        if (offer1FreebieValue && cartSubtotal > offer1FreebieValue && !giftCard.length) {
          const variantObjects = createVariantsObject(offer1FreebieVariantIds)
          freebieVariantIds.push(...offer1FreebieVariantIds)
          freebieVariantObjects.push(...variantObjects)
        }
        if (offer2FreebieValue && cartSubtotal > offer2FreebieValue && !giftCard.length) {
          const variantObjects = createVariantsObject(offer2FreebieVariantIds)
          freebieVariantIds.push(...offer2FreebieVariantIds)
          freebieVariantObjects.push(...variantObjects)
        }
        if (offer3MinCartQty && tagPresenceCount >= offer3MinCartQty && !giftCard.length) {
          const variantObjects = createVariantsObject(offer3MinCartQtyVariantIds)
          freebieVariantIds.push(...offer3MinCartQtyVariantIds)
          freebieVariantObjects.push(...variantObjects)
        }
        if (offer3MinCartQty2 && tagPresenceCount >= offer3MinCartQty2 && !giftCard.length) {
          const variantObjects = createVariantsObject(offer3MinCartQtyVariantIds2)
          freebieVariantIds.push(...offer3MinCartQtyVariantIds2)
          freebieVariantObjects.push(...variantObjects)
        }
        if (offer3FreebieValue && cartSubtotal > offer3FreebieValue && !giftCard.length) {
          const variantObjects = createVariantsObject(offer3FreebieVariantIds)
          freebieVariantIds.push(...offer3FreebieVariantIds)
          freebieVariantObjects.push(...variantObjects)
        }
        if (offer4FreebieValue && cartSubtotal > offer4FreebieValue && !giftCard.length) {
          const variantObjects = createVariantsObject(offer4FreebieVariantIds)
          freebieVariantIds.push(...offer4FreebieVariantIds)
          freebieVariantObjects.push(...variantObjects)
        }
        if (offer3MinCartQty3 && tagPresenceCount >= offer3MinCartQty3 && !giftCard.length) {
          const variantObjects = createVariantsObject(offer3MinCartQtyVariantIds3)
          freebieVariantIds.push(...offer3MinCartQtyVariantIds3)
          freebieVariantObjects.push(...variantObjects)
        }
        if (offer3MinCartQty4 && tagPresenceCount >= offer3MinCartQty4 && !giftCard.length) {
          const variantObjects = createVariantsObject(offer3MinCartQtyVariantIds4)
          freebieVariantIds.push(...offer3MinCartQtyVariantIds4)
          freebieVariantObjects.push(...variantObjects)
        }
        
        let data = { items: [...freebieVariantObjects] }
        if(document.getElementById("quantity-message")){
          data['sections'] = "cart-drawer,cart-icon-bubble,quantity-message";
        }
        else{
          data['sections'] = "cart-drawer,cart-icon-bubble";
        }
        data['sections_url'] = "/cart";
        
        updateCart = freebieVariantObjects.length ? true : false

        if (updateCart) {
          fetch('/cart/add.js', {
              method: 'POST', 
              headers: {
              'Content-Type': 'application/json'
              },
              body: JSON.stringify(data)
          })
          .then((response) =>
            response.json()
          )
          .then((data) => {
            let myCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            myCart.renderContents(data);
            if(data.items.length > 0 && document.querySelector('cart-drawer').getAttribute("data-show-confettiShooter") == 'true') {
              setTimeout(() => {
                window.confettiShooter();
              }, 600);
            }
          })
        } 
       }
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    const sections = [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];

    if (document.getElementById('quantity-message')) {
      sections.push({
        id: 'quantity-message',
        section: 'quantity-message',
        selector: '#quantity-message'
      });
    }

    return sections;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


//checkout spinner 
let cartCheckout = document.querySelector('#CartDrawer-Checkout')?.addEventListener('click',()=>{
  document.querySelector('#checkout_text_icon').style.display="none";
  document.querySelector('#loader_wrapper').style.display ="flex";
})

class customRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
    this.showCart = true;
  }

  connectedCallback() {
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.removeBundleFromCart();
    });
  }

  removeBundleFromCart() {
    const removeButton = this.querySelector('button');

    if (!removeButton || !removeButton.dataset.removehasaddictedtogoodbox) {
      console.error("Remove button or dataset is missing.");
      return;
    }

    let variantIds = removeButton.dataset.removehasaddictedtogoodbox.split(', ');

    let updates = {};
    variantIds.forEach((id) => {
      if(id !== ""){
        let variantId = id.split(":")[0].trim();
        updates[variantId] = 0;
      }
    });

    const payload = {
      updates: updates,
      sections: this.cart.getSectionsToRender().map(({ id }) => id),
      sections_url: window.location.pathname
    };

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
    .then(response => response.json())
    .then(data => {
      this.cart.renderContents(data, this.showCart);
    })
    .catch(error => {
      console.error("Error updating cart:", error.message);
    });
  }
}

customElements.define('custom-remove-button', customRemoveButton);

class BundleEdit extends HTMLElement {
  constructor(){
    super();
  }

  connectedCallback(){
    this.productsList = JSON.parse(this.dataset.bundleArray);
    this.buildABoxPage = window.location.origin + this.dataset.collection;
    this.uniqueProperty = this.dataset.uniqueProperty;

    this.addEventListener('click', this.editBundleItems.bind(this));
  }

  editBundleItems(event){
    event.preventDefault();
    localStorage.setItem('boxProducts', JSON.stringify(this.productsList));
    
    const data = {
      bundleItems: JSON.stringify(this.productsList),
      uniqueProperty: this.uniqueProperty
    };

    localStorage.setItem('updateBundleProduct', JSON.stringify(data));
    window.location.href = this.buildABoxPage;
  }
}

customElements.define('bundle-edit', BundleEdit);